import { Component, OnInit } from '@angular/core';
import { TogglService } from '../toggl.service';
import { UnmatchedJob } from '../toggl.types';

@Component({
    selector: 'app-toggl-job-match',
    templateUrl: './toggl-job-match.component.html',
    styleUrls: ['./toggl-job-match.component.scss']
})
export class TogglJobMatchComponent implements OnInit {

    constructor(private togglService: TogglService) { }

    gotResults: boolean = false;
    total: number = 0;
    matched: number = 0;
    unmatched: number = 0;
    unmatchedJobs: UnmatchedJob[] = [];
    matchedJobs: UnmatchedJob[] = [];
    
    ngOnInit(): void {
        this.togglService.getMatchedJobCounts().subscribe({
            next: (r) => {
                console.log(r);
                this.total = r.total;
                this.matched = r.matched;
                this.unmatched = r.unmatched;
                this.unmatchedJobs = r.unmatchedJobs;
                this.matchedJobs = r.matchedJobs;
                this.gotResults = true;
            }
        });
    }

    matchJobs() {
        this.togglService.updateUnmatchedJobs().subscribe({
            next: (r) => {
                this.total = r.total;
                this.matched = r.matched;
                this.unmatched = r.unmatched;
                this.unmatchedJobs = r.unmatchedJobs;
                this.gotResults = true;
            }
        });
    }

}